import { render, staticRenderFns } from "./AgendaCard.vue?vue&type=template&id=7cae1b7e&"
import script from "./AgendaCard.vue?vue&type=script&lang=js&"
export * from "./AgendaCard.vue?vue&type=script&lang=js&"
import style0 from "./AgendaCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
